import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md shadow-sm hover:shadow-md transition-shadow" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0 text-lg font-semibold" }
const _hoisted_5 = { class: "trezo-card-subtitle" }
const _hoisted_6 = { class: "trezo-card-dropdown relative" }
const _hoisted_7 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px] font-medium" }
const _hoisted_8 = {
  key: 0,
  class: "trezo-card-dropdown-menu transition-all bg-white shadow-lg rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-[#0c1427] dark:shadow-md"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "trezo-card-content",
  style: {"min-height":"420px"}
}
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center items-center h-[420px]"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col justify-center items-center h-[420px] text-center px-6"
}
const _hoisted_13 = { class: "text-danger-500 font-medium mb-2" }
const _hoisted_14 = { class: "text-gray-500 dark:text-gray-400 text-sm" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-col justify-center items-center h-[420px] text-center px-6"
}
const _hoisted_16 = { class: "text-gray-700 dark:text-gray-300 font-medium mb-2" }
const _hoisted_17 = { class: "text-gray-500 dark:text-gray-400 text-sm" }
const _hoisted_18 = {
  key: 3,
  class: "-mx-[20px] md:-mx-[25px]"
}
const _hoisted_19 = { class: "table-responsive overflow-x-auto" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "text-black dark:text-white" }
const _hoisted_22 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md last:rounded-tr-md" }
const _hoisted_23 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_24 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_25 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_26 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[12px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_27 = { class: "text-black dark:text-white" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "rounded-full w-[40px] h-[40px] overflow-hidden border border-gray-100 dark:border-[#172036] shadow-sm" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_33 = { class: "block font-medium" }
const _hoisted_34 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_36 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_37 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_38 = { class: "flex items-center gap-[12px]" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px] sm:flex sm:items-center justify-between" }
const _hoisted_42 = { class: "mb-0 text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_43 = { class: "mt-[10px] sm:mt-0 flex" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_46 = { class: "bg-white dark:bg-[#0c1427] p-5 sm:p-6 rounded-lg shadow-xl w-full max-w-md mx-2 sm:mx-4 z-10 relative transform transition-all" }
const _hoisted_47 = { class: "flex justify-between items-center mb-5" }
const _hoisted_48 = { class: "text-lg font-semibold text-black dark:text-white" }
const _hoisted_49 = { class: "mb-6" }
const _hoisted_50 = { class: "text-gray-700 dark:text-gray-300 text-sm sm:text-base" }
const _hoisted_51 = { class: "flex justify-between items-center pt-3" }
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.recentLeads')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500 focus:outline-none': true,
              active: _ctx.isActive,
            }),
              id: "dropdownToggle",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.selectedTimeFilter) + " ", 1),
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
              ])
            ], 2),
            (_ctx.isActive)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeFilters, (filter) => {
                    return (_openBlock(), _createElementBlock("li", { key: filter }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-[#172036]",
                        onClick: ($event: any) => (_ctx.applyTimeFilter(filter))
                      }, _toDisplayString(filter), 9, _hoisted_9)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 opacity-75" }, null, -1)
            ])))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-danger-500 text-3xl mb-3" }, [
                  _createElementVNode("i", { class: "ri-error-warning-line" })
                ], -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.directT('dashboard.crm.unableToLoadLeads')), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.error), 1)
              ]))
            : (_ctx.leads.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-gray-400 text-3xl mb-3" }, [
                    _createElementVNode("i", { class: "ri-file-list-3-line" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.directT('dashboard.crm.noLeadsFound')), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.directT('dashboard.crm.tryChangingFilter')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("table", _hoisted_20, [
                      _createElementVNode("thead", _hoisted_21, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('dashboard.customer')), 1),
                          _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('dashboard.crm.email')), 1),
                          _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.directT('dashboard.crm.source')), 1),
                          _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.directT('dashboard.status')), 1),
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.directT('dashboard.crm.action')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id,
                            class: "hover:bg-gray-50 dark:hover:bg-[#172036] transition-colors"
                          }, [
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("img", {
                                    src: _ctx.getLeadAvatar(item),
                                    class: "w-full h-full object-cover",
                                    alt: "user-image"
                                  }, null, 8, _hoisted_31)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(item.name), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(item.email), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(item.source), 1),
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("span", {
                                class: "px-[10px] py-[4px] inline-block rounded-md font-medium text-xs",
                                style: _normalizeStyle(_ctx.getStatusClass(item.status))
                              }, _toDisplayString(item.status), 5)
                            ]),
                            _createElementVNode("td", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip hover:text-primary-500 transition-colors",
                                  id: "customTooltip",
                                  "data-text": "Edit",
                                  onClick: ($event: any) => (_ctx.editLead(item))
                                }, _cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                                ]), 8, _hoisted_39),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip hover:text-danger-500 transition-colors",
                                  id: "customTooltip",
                                  "data-text": "Delete",
                                  onClick: ($event: any) => (_ctx.deleteLead(item))
                                }, _cache[12] || (_cache[12] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                                ]), 8, _hoisted_40)
                              ])
                            ])
                          ]))
                        }), 128)),
                        (_ctx.paginatedItems.length < 5)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((5 - _ctx.paginatedItems.length), (i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `placeholder-${i}`
                              }, _cache[13] || (_cache[13] = [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "border-b border-gray-100 dark:border-[#172036] h-[65px]"
                                }, null, -1)
                              ])))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.directT('dashboard.showingResults').replace('{start}', String(_ctx.startItem + 1)).replace('{end}', String(_ctx.endItem)).replace('{total}', String(_ctx.leads.length))), 1),
                    _createElementVNode("ol", _hoisted_43, [
                      _createElementVNode("li", {
                        class: _normalizeClass(["mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === 1 }])
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "w-[32px] h-[32px] flex items-center justify-center relative text-center rounded-md border border-gray-200 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500 disabled:opacity-50",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                        }, _cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, " chevron_left ", -1)
                        ]))
                      ], 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { active: _ctx.currentPage === page }]),
                          key: page
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "w-[32px] h-[32px] flex items-center justify-center relative text-center rounded-md border border-gray-200 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
                            onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                          }, _toDisplayString(page), 9, _hoisted_44)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", {
                        class: _normalizeClass(["mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === _ctx.totalPages }])
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "w-[32px] h-[32px] flex items-center justify-center relative text-center rounded-md border border-gray-200 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500 disabled:opacity-50",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                        }, _cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, " chevron_right ", -1)
                        ]))
                      ], 2)
                    ])
                  ])
                ]))
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.directT('dashboard.crm.confirmDeletion')), 1),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2 rounded-full hover:bg-gray-100 dark:hover:bg-[#172036] transition-colors"
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_49, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-danger-500 text-center mb-4" }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-3xl" }, "warning")
              ], -1)),
              _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.directT('dashboard.crm.deleteConfirmation')), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "inline-block py-[10px] px-[20px] bg-gray-200 text-gray-700 dark:bg-[#172036] dark:text-gray-300 transition-all hover:bg-gray-300 dark:hover:bg-[#15203c] rounded-md"
              }, [
                _createElementVNode("span", _hoisted_52, [
                  _cache[18] || (_cache[18] = _createElementVNode("i", { class: "material-symbols-outlined mr-2" }, "close", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('dashboard.crm.cancel')), 1)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "inline-block py-[10px] px-[20px] bg-danger-500 text-white transition-all hover:bg-danger-400 rounded-md shadow-sm"
              }, [
                _createElementVNode("span", _hoisted_53, [
                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "material-symbols-outlined mr-2" }, "delete", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('dashboard.crm.delete')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}